import '../../Style/font_responsive.css';

function CusIconLabel({Icon, text}){
    return(
        <div>
            
            <label className="normal-text"><Icon /> {" " + text}</label>
        </div>
    );
}

export default CusIconLabel;